export const emptyMeetingType = {
    term_id: 0,
    type: "",
    name: "",
    price: 0,
    seats: 0,
    duration_in_minutes: 0,
    for_sale: false,
};
export const emptyMonth = {
    month: 0,
    month_name: "",
    year: "",
    previous_month: 0,
    next_month: 0,
};
export const emptyCalendar = {
    month: emptyMonth,
    weekday_names: [],
    days: [],
    weeks: [],
};
export const emptyDay = {
    day: 0,
    month: 0,
    formatted: "",
    day_number: "",
    month_number: "",
    weekday_short: "",
    weekday_long: "",
    is_current_day: false,
    meetings: [],
};
